<template>
  <div>
    <my-notification :icon="'crosshairs'">
      <template #title>
        {{ $t('compScenarioAdminAllScenarios.title') }}
      </template>
      <span v-html="$t('compScenarioAdminAllScenarios.info-1')" />
      {{ $t('t.co2e') }}.
    </my-notification>
    <br />
    <b-notification
      :style="{ padding: '0.0rem 0rem 0rem 0rem' }"
      :closable="false"
    >
      <nav class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="panel-block">
            <b-tooltip
              :label="$t('compScenarioAdminAllScenarios.info-4')"
              :append-to-body="true"
              type="is-black"
            >
              <b-button
                @click="display = 'chart'"
                :type="display === 'chart' ? 'is-primary' : ''"
                size="is-small"
                class="button"
                icon-left="pie-chart"
              />
            </b-tooltip>
            <b-tooltip
              :label="$t('compScenarioAdminAllScenarios.info-5')"
              :append-to-body="true"
              type="is-black"
            >
              <b-button
                @click="display = 'table'"
                :type="display === 'table' ? 'is-primary' : ''"
                size="is-small"
                class="button"
                icon-left="th-list"
              />
            </b-tooltip>
          </div>
        </div>
      </nav>
    </b-notification>
    <div v-if="display === 'chart'">
      <div
        :style="{ 'margin-left': '2px', 'margin-bottom': '10px' }"
        class="columns is-multiline"
      >
        <div
          v-for="(scenario, index) in adminStore.allScenarios"
          :key="index"
          class="column is-3"
          :style="{ 'padding-left': 0, 'padding-right': '1.5rem' }"
        >
          <div class="card">
            <div class="card-image">
              <scenario-area
                :height="250"
                :scenario="scenario"
                :ghgi="scenario.ghgi"
                :exporting="false"
                :modules="coreStore.activeModules(true)"
                :colors="colors"
              />
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">{{ scenario.name }}</p>
                  <p class="subtitle is-6">
                    {{ scenario.reductionRate }} %
                    {{ $t('compScenarioAdminAllScenarios.info-6') }}
                    {{ scenario.ghgi.year }} - {{ scenario.timeline }}
                  </p>
                </div>
              </div>
              <div class="content is-centered has-text-centered">
                <div>
                  <b-tooltip
                    :label="$t('compScenarioAdminAllScenarios.tooltip-1')"
                    type="is-black"
                  >
                    <b-button
                      size="is-small"
                      icon-left="cloud-download"
                      @click="loadScenario(scenario.uuid)"
                    />
                  </b-tooltip>
                  <b-tooltip
                    :label="$t('compScenarioAdminAllScenarios.tooltip-3')"
                    type="is-black"
                  >
                    <b-button
                      size="is-small"
                      icon-left="external-link"
                      @click="copyLink(scenario.id)"
                    />
                  </b-tooltip>
                  <b-tooltip
                    :label="$t('compScenarioAdminAllScenarios.tooltip-2')"
                    type="is-black"
                  >
                    <b-button
                      size="is-small"
                      icon-right="trash"
                      @click="deleteScenario(scenario)"
                    />
                  </b-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3" key="add-btn">
          <label class="upload control is-expanded" @click="createScenario()">
            <div class="upload-draggable is-info is-expanded">
              <section class="section">
                <div
                  class="content is-vcentered has-text-centered"
                  :style="{ height: '300px' }"
                >
                  <p>
                    <span class="icon">
                      <i class="fa fa-plus" style="font-size: 36px"></i>
                    </span>
                  </p>
                  <p>{{ $t('compScenarioAdminAllScenarios.label-1') }}</p>
                </div>
              </section>
            </div>
          </label>
        </div>
      </div>
    </div>
    <div v-else-if="display === 'table'">
      <b-table
        :data="adminStore.allScenarios"
        :striped="true"
        :narrowed="true"
        :hoverable="true"
      >
        <b-table-column
          :label="$t('compScenarioAdminAllScenarios.field-1')"
          sticky
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          :label="$t('compScenarioAdminAllScenarios.field-2')"
          v-slot="props"
        >
          {{ props.row.ghgi.year }}
        </b-table-column>
        <b-table-column
          :label="$t('compScenarioAdminAllScenarios.field-3')"
          v-slot="props"
        >
          {{ props.row.timeline }}
        </b-table-column>
        <b-table-column
          :label="$t('compScenarioAdminAllScenarios.field-5')"
          v-slot="props"
        >
          {{ props.row.reductionRate }} %
        </b-table-column>
        <b-table-column
          :label="$t('compScenarioAdminAllScenarios.field-4')"
          v-slot="props"
        >
          <b-taglist>
            <b-tag v-for="(rule, index) in props.row.rules" :key="index">
              {{ translate(rule, 'title') }}
            </b-tag>
          </b-taglist>
        </b-table-column>
        <b-table-column :width="40" v-slot="props">
          <div class="panel-block">
            <b-tooltip
              :label="$t('compScenarioAdminAllScenarios.tooltip-1')"
              type="is-black"
            >
              <b-button
                size="is-small"
                icon-left="cloud-download"
                @click="loadScenario(props.row.uuid)"
              />
            </b-tooltip>
            <b-tooltip
              :label="$t('compScenarioAdminAllScenarios.tooltip-3')"
              type="is-black"
              position="is-left"
            >
              <b-button
                size="is-small"
                icon-left="external-link"
                @click="copyLink(props.row.id)"
              />
            </b-tooltip>
            <b-tooltip
              :label="$t('compScenarioAdminAllScenarios.tooltip-2')"
              type="is-black"
              position="is-left"
            >
              <b-button
                size="is-small"
                icon-right="trash"
                @click="deleteScenario(props.row)"
              />
            </b-tooltip>
          </div>
        </b-table-column>
        <section slot="empty" class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <i class="fa fa-ban" style="font-size: 64px"></i>
            </p>
            <p>{{ $t('compScenarioAdminAllScenarios.info-2') }}</p>
          </div>
        </section>
      </b-table>
      <br />
      <nav class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="buttons">
            <b-button class="button" icon-left="plus" @click="createScenario()">
              {{ $t('add') }}
            </b-button>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Rule from '@/models/scenario/Rule.js'
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'AllScenarios',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'scenario-area': () => import('@/components/graphics/ScenarioArea.vue')
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const coreStore = useCoreStore()
    return { adminStore, authStore, coreStore }
  },
  data () {
    return {
      display: 'chart'
    }
  },
  computed: {
    colors: function () {
      return this.coreStore.modulesColors
    }
  },
  methods: {
    translate (rule, key) {
      return Rule.translate(rule, key, this.$i18n.locale)
    },
    createScenario () {
      this.$router.push('/scenario-1point5/0')
    },
    loadScenario (uuid) {
      this.$router.push('/scenario-1point5/' + uuid)
    },
    copyLink (id) {
      let scenario = this.adminStore.allScenarios.find((obj) => obj.id === id)
      let route = this.$router.resolve({
        path: '/scenario-1point5-results/' + scenario.uuid
      })
      window.open(route.href, '_blank')
    },
    deleteScenario (scenario) {
      let self = this
      this.$buefy.dialog.confirm({
        title:
          self.$t('compScenarioAdminAllScenarios.title-2') +
          ' ' +
          scenario.name,
        message:
          self.$t('compScenarioAdminAllScenarios.info-3') +
          ' <b> ' +
          scenario.name +
          '</b> ?',
        confirmText: self.$t('validate'),
        cancelText: self.$t('cancel'),
        canCancel: ['escape', 'button', 'outside'],
        onConfirm: function () {
          const loadingComponent = self.$buefy.loading.open({
            container: null
          })
          self.adminStore
            .deleteScenario(scenario.id)
            .then((data) => {
              loadingComponent.close()
            })
            .catch((erreur) => {
              loadingComponent.close()
            })
        }
      })
    }
  },
  mounted () {
    if (this.authStore.isAuthenticated) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.adminStore
        .getScenarios()
        .then((data) => {
          loadingComponent.close()
        })
        .catch((erreur) => {
          loadingComponent.close()
        })
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
.table th {
  vertical-align: middle !important;
}
</style>
